import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  primaryLinks: Array<{ label: string; url: string }> = [
    {
      label: 'About us',
      url: 'https://www.domesticandgeneral.com/corporate/about-us',
    },
    {
      label: 'Help and advice',
      url: 'https://www.domesticandgeneral.com/content/help-advice-section/faq',
    },
    {
      label: 'Contact us',
      url: 'https://www.domesticandgeneral.com/content/contact-domestic-general',
    },
  ];

  secondaryLinks: Array<{ label: string; url: string }> = [
    {
      label: 'Website Terms and Conditions',
      url: 'https://www.domesticandgeneral.com/web-terms-conditions',
    },
    {
      label: 'Privacy and Cookies policy',
      url: 'https://www.domesticandgeneral.com/privacy-cookies-policy',
    },
    {
      label: 'Accessibility policy',
      url: 'href="https://www.domesticandgeneral.com/accessibility"',
    },
  ];
}
